import EventConfirmPendingController from "../confirm_pending_controller"

# Proxy controller to EventConfirmPendingController for semantic reasons
export default class extends EventConfirmPendingController